<template>
    <BCard>
      <ValidationObserver ref="form" #default="{invalid}">
          <BForm @submit.prevent="onSubmit">
              <BRow>
                <TextInputValidated vsName="Name" :vsModel.sync="teacher.name" vsMd="6" vsRules="required" vsRequired />
                <TextInputValidated vsName="Surname" :vsModel.sync="teacher.surname" vsMd="6" vsRules="required" vsRequired />
                <TextInputValidated vsName="Address" :vsModel.sync="teacher.address" vsMd="6" />
                <TextInputValidated vsName="Email" :vsModel.sync="teacher.email" vsMd="6" vsRules="required" vsRequired />
                <TextInputValidated vsName="Phone" :vsModel.sync="teacher.phone" vsMd="6" />
                <vSelectValidated vsName="Groups" v-if="groups && groups.length>1" :vsModel.sync="teacher.groups" :vsOptions="groups" vsLabel="name" vsMd="6" vsMultiple vsRequired vsRules="required"/>
                <vSelectValidated vsName="Status" :vsModel.sync="teacher.status" :vsOptions="statusOptions" vsLabel="label" vsMd="6" vsRequired vsRules="required" :vsReduce="status => status.value" />
                <TextareaValidated vsName="Observations" :vsModel.sync="teacher.observations" vsMd="6" />
              </BRow>

              <!-- Action Buttons -->
              <BButton variant="primary" class="mt-3 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
              <BButton variant="outline-secondary" class="mt-4" type="reset" :to="{ name:'teachers' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
          </BForm>
      </ValidationObserver>
  </BCard>
</template>

<script>
import { BCard, BRow, BCol, BForm, BButton, BFormInput, BFormTextarea, BFormGroup, BFormInvalidFeedback, BFormDatepicker } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { inject } from '@vue/composition-api';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import TextareaValidated from '@/components/forms/TextareaValidated.vue';
import vSelectValidated from '@/components/forms/vSelectValidated.vue'
import popups from '@/hooks/popups';
import store from '@/store';

export default {
  components: { BCard, BRow, BCol, BForm, BButton, BFormInput, BFormTextarea, BFormGroup, BFormInvalidFeedback, BFormDatepicker, ValidationProvider, ValidationObserver, extend, TextInputValidated, TextareaValidated, vSelectValidated },
  setup(){
      const { errorToast } = popups()
      const teacher = inject('teacher')
      const groups = inject('groups')

      const statusOptions = [
        { label: 'Activo', value: true },
        { label: 'Inactivo', value: false },
      ]

      const onSubmit = function(){
          this.$refs.form.validate().then(success => {
              if(success) {
                console.log("entro")
                  store.dispatch('teachers/addTeacher', JSON.parse(JSON.stringify(teacher.value)))
                      .then(response => { this.$router.push({ name: 'teachers' }) })
                      .catch(error => { errorToast('Can\'t add teacher') })
              }
          })
      }

      return {
          statusOptions,
          onSubmit,
          teacher,
          groups,
      }
  }
}
</script>
